import { render, staticRenderFns } from "./ProfileSection.vue?vue&type=template&id=58e7d322&scoped=true&"
import script from "./ProfileSection.vue?vue&type=script&lang=ts&"
export * from "./ProfileSection.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileSection.vue?vue&type=style&index=0&id=58e7d322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e7d322",
  null
  
)

export default component.exports